var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { isDark } from '../../utilities/color-utils';
import { Icon } from '../Icon';
import { Button } from '../Button';
export const Tag = (_a) => {
    var { badge, children, className, color = 'default', compact, icon: iconName, onClose, subtle, title, tagRef } = _a, props = __rest(_a, ["badge", "children", "className", "color", "compact", "icon", "onClose", "subtle", "title", "tagRef"]);
    const isCustomColor = () => {
        const uniqueColors = [
            'info',
            'warning',
            'critical',
            'success',
            'inactive',
            'default',
            'inverse',
        ];
        if (!uniqueColors.includes(color))
            return true;
        return false;
    };
    const getColorClasses = () => {
        if (isCustomColor())
            return isDark(color) ? 'Tag--lightText' : 'Tag--darkText';
        if (!isCustomColor())
            return `Tag--${color}`;
    };
    const TagClasses = classnames('Tag', className, getColorClasses(), {
        'Tag--compact': compact,
        'Tag--subtle': subtle,
        'Tag--badge': badge,
    });
    const getTextFromChildren = (children) => {
        return React.Children.toArray(children)
            .reduce((flattened, child) => {
            var _a;
            return [
                ...flattened,
                ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.children)
                    ? getTextFromChildren(child.props.children)
                    : child,
            ];
        }, [])
            .filter((str) => !str.toString().includes('object Object'))
            .join('');
    };
    const actualTitle = title !== undefined ? title : `Tag: ${getTextFromChildren(children)}`;
    return (React.createElement("div", Object.assign({ className: TagClasses, title: actualTitle, style: isCustomColor() ? { backgroundColor: color } : null, ref: tagRef, "data-anvil-component": "Tag" }, props),
        iconName ? (React.createElement("span", { className: "Tag__icon" },
            React.createElement(Icon, { name: iconName, size: compact ? 14 : 16 }))) : null,
        React.createElement("span", { className: "Tag__body" }, children),
        onClose && (React.createElement(Button, { "aria-label": "remove tag", fill: "subtle", className: "Tag__close", iconName: "clear", size: "xsmall", onClick: onClose }))));
};
//# sourceMappingURL=Tag.js.map